import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { interval, of, Subscription } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { CognitoServiceService } from './cognito-service.service';

@Injectable({
  providedIn: 'root'
})
export class TokenRefreshSchedulerService {
  private static readonly REFRESH_CHECK_INTERVAL_MS = 15000;
  private refreshCheckSub: Subscription | null = null;

  constructor(
    private cognitoService: CognitoServiceService,
    private router: Router
  ) {}

  start(): void {
    if (this.refreshCheckSub) {
      return;
    }

    this.refreshCheckSub = interval(TokenRefreshSchedulerService.REFRESH_CHECK_INTERVAL_MS).pipe(
      startWith(0),
      switchMap(() => {
        const hasIdToken = !!sessionStorage.getItem('id_token');
        const hasRefreshToken = !!sessionStorage.getItem('refresh_token');

        if (!hasIdToken && !hasRefreshToken) {
          return of(true);
        }

        return this.cognitoService.ensureValidIdToken(30);
      })
    ).subscribe((isTokenValid) => {
      if (!isTokenValid) {
        sessionStorage.removeItem('refresh_token');

        if (this.router.url !== '/logoff') {
          this.router.navigate(['/logoff'], { state: { logoutSource: 'session_expired' } });
        }
      }
    });
  }

  stop(): void {
    if (this.refreshCheckSub) {
      this.refreshCheckSub.unsubscribe();
      this.refreshCheckSub = null;
    }
  }
}
